module.exports = __webpack_public_path__ + "static/9-6bff696c078d7794288e10e4694b997e.jpg";